import { useEffect, useState } from 'react';

import { bopsApi } from '@Network';
import config from '../../config';
import CenteredLayout from './components/CenteredLayout';
import { EmptyStateTone } from './components/GreetingHeading';
import Gs1Provisioning from './components/Gs1Provisioning';
import { MotifKind } from './components/Motif';

interface EmptyStateProps {
  motif?: MotifKind;
  tone?: EmptyStateTone;
  userName?: string;
}

const EmptyState = ({ motif = 'halo', tone = 'ready', userName }: EmptyStateProps) => {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Only the `bops` flavor uses Slack-based user provisioning alerts.
    // gs1mex has its own auto-provisioning flow (Gs1Provisioning) and logyca
    // has its own onboarding flow; they do not consume this notification.
    if (config.REACT_APP_FLAVOR !== 'bops') return;
    bopsApi.notifyNoClient().catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('notifyNoClient failed', err);
    });
  }, []);

  // GS1 SMB suppliers without a clientId are auto-provisioned by their token
  // GLN. The provisioning subflow takes over the EmptyState slot for this
  // flavor and transitions out by refreshing the token + refetching config.
  if (config.isGs1Flavor) return <Gs1Provisioning />;

  return (
    <div className="flex-1 flex flex-col min-h-0 bg-background animate-es-fade-in">
      <CenteredLayout
        motif={motif}
        tone={tone}
        submitted={submitted}
        onSubmit={() => setSubmitted(true)}
        name={userName}
      />
    </div>
  );
};

export default EmptyState;
